<div class="with-text"
  [class.text-align--left]="textAlign === 'left'"
  >
  <div class="component">
    <ng-content></ng-content>
  </div>

  <div class="text-container">
    <div class="text"
      [class.transparent-background]="transparentBackground"
      >
      @if (preHeader) {
        <h3
          class="serif text--pre-header"
          >
          {{ preHeader }}
        </h3>
      }

      <h2 class="text--header">
        {{ header }}
      </h2>

      <p class="text--content"
        [innerHTML]="content | safe:'html'"
      ></p>

      @if (buttonsToRender.length) {
        <div
          class="buttons-container"
          >
          @for (button of buttonsToRender; track button) {
            <app-button
              [href]="button.link.link"
              [type]="button.link.link ? 'link' : 'button' "
              [cmsTheme]="button.type"
              [cmsIcon]="button.icon ?? undefined"
                            [layout]="(button?.icon && button.link.label === ' ') ? 'icon-only'
                                : (button?.icon && button.link.label) ? 'icon-label'
                                : 'label-only'
                            "
              [cmsTarget]="button.link.target"
              >
              {{ button.link.label }}
            </app-button>
          }
        </div>
      }
    </div>
  </div>
</div>
